import { render, staticRenderFns } from "./personupdata.vue?vue&type=template&id=4c89eb7e&"
import script from "./personupdata.vue?vue&type=script&lang=js&"
export * from "./personupdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports